import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {SystemStatus, SystemStatusDTO} from "./system-status";
import {interval, merge, Subject} from "rxjs";
import {catchError, filter, startWith, switchMap} from "rxjs/operators";
import {of} from "rxjs";
import {ApiRouteConfig} from "../../../../config/api.route.config";
import {logAsync} from '../../../../helpers/logging';


@Injectable()
export class SystemStatusPollerService {
  public readonly tick_interval = 300_000;

  private forceFetch = new Subject();
  private updateTick = merge(
      interval(this.tick_interval).pipe(logAsync('📟 System status: polling interval expired')),
      this.forceFetch,
  );

  constructor(
      private readonly state: SystemStatus,
      private readonly http: HttpClient,
      private readonly api: ApiRouteConfig,
  ) {
    console.log('📟 System status: polling started', this.tick_interval / 1000,'seconds')
    this.updateTick.pipe(
        startWith(0),
        switchMap(() => this.runCheck()),
        filter(status => !!status)
    ).subscribe(status => {
      this.state.update(status);
    });
  }

  public refresh() {
    this.forceFetch.next();
  }

  private runCheck() {
    return this.http.get<SystemStatusDTO>(this.api.SYSTEM_STATUS).pipe(
        catchError(error => {
          return of(null);
        }),
    );
  }
}
